/** Тип возвращаемого от api */
export enum TypeReturn {
  json,
  string
}